import {testIdProps} from '@github-ui/test-id-props'
import {clsx} from 'clsx'
import {memo, type ReactNode} from 'react'

import {ObserverProvider} from '../../../components/board/hooks/use-is-visible'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {Loader, NoArchivedItems, NoFilteredItems} from './archive-empty-states'
import styles from './archive-list.module.css'
import {ArchiveListItem} from './archive-list-item'

type ArchiveListProps = React.PropsWithChildren<{
  filteredItems: Array<MemexItemModel>
  loaded: boolean
  hasArchive: boolean
  renderItem: (item: MemexItemModel) => ReactNode
  className?: string
}>

export const ArchiveList = memo<ArchiveListProps>(function ArchiveListComponent({
  filteredItems,
  loaded,
  hasArchive,
  renderItem,
  className,
}) {
  return (
    <ul className={clsx(styles.Box, className)} {...testIdProps('archived-item-list')}>
      {!loaded ? (
        <li {...testIdProps('archived-item-loader')}>
          <Loader />
        </li>
      ) : !hasArchive ? (
        <li>
          <NoArchivedItems />
        </li>
      ) : filteredItems.length === 0 ? (
        <li>
          <NoFilteredItems />
        </li>
      ) : (
        <ObserverProvider rootRef={null} sizeEstimate={55}>
          {filteredItems.map(item => (
            <ArchiveListItem key={item.id}>{renderItem(item)}</ArchiveListItem>
          ))}
        </ObserverProvider>
      )}
    </ul>
  )
})
